// @flow
import { connect } from 'react-redux';
import DualSpinnerBase from '../base';
import { getConfig } from '~/core/state/config/selectors';

const YELLOW = { r: 246, g: 199, b: 42 };
const ORANGE = { r: 231, g: 97, b: 54 };
const CELSIUS_MID_TEMP = 20.5;

type RGB = { r: number, g: number, b: number };

const mapStateToProps = (
    state,
    { isDualSpinner, isSingleBGColorOnly, mode, isBoosting, maxHeat, minHeat, comfortZone, disabled }
): {
    aboveColor: null | RGB,
    belowColor: null | RGB,
    bgColor: RGB,
    disabled: boolean,
    interval: string,
    isBoosting: boolean,
    maxTemp: number,
    metric: string,
    midTemp: number,
    minTemp: number,
    mode: string
} => {
    const heatingMaxTempPath = `products:heating:${isDualSpinner ? 'maxTempDual' : 'maxTemp'}`;
    const metric = getConfig(state, 'products:heating:metric');

    const maxTemp = (maxHeat && maxHeat - (isDualSpinner ? comfortZone : 0)) || getConfig(state, heatingMaxTempPath);
    const minTemp = minHeat || getConfig(state, 'products:heating:minTemp');
    const midTemp = CELSIUS_MID_TEMP;

    const aboveColor = isSingleBGColorOnly ? null : ORANGE;
    const belowColor = isSingleBGColorOnly ? null : YELLOW;
    const interval = getConfig(state, 'products:heating:interval');

    return {
        aboveColor,
        bgColor: ORANGE,
        belowColor,
        interval,
        maxTemp,
        metric,
        midTemp,
        minTemp,
        mode,
        isBoosting,
        disabled
    };
};

export default connect(mapStateToProps)(DualSpinnerBase);



// WEBPACK FOOTER //
// ./src/components/widgets/temperature-spinner/dual-color-range/heating/index.js